/* eslint-disable */
/* eslint-disable prefer-template */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { BaseComponent } from '../../../components/BaseComponent';
import { FormField, FormFields } from '../../../components/FormFields';
import { Button } from '../../../components/Buttons';
import { HBox, VBox } from '../../../components/Box';
import DatePicker from 'react-datepicker';
import { createInvoice } from '../actions';
import { Content } from '../../../components/Content';
import { Input } from '../../../components/Form';
import { Dropdown } from '../../../components/Dropdown';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { Checkbox } from '../../../components/Checkbox';
import { VehicleSelection } from '../components/VehicleSelection';
import _ from 'lodash';
import { INVOICE_DIRECTIONS } from '../constants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { fetchCompany, setCompanyProperty } from '../../Companies/actions';
import { calculateFinancialAmounts } from '../actions';
import { selectCompany } from '../selectors';
import { IncomingCostTypes, OutgoingCostTypes } from '../constants';
import { getPropByName } from '../../../utils/props';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectConfig } from '../../Api/selectors';
import { WIENTJES_INSTALATION } from '../../../containers/App/constants';
import { formatedDateNow, getDaysBetweenDates } from '../../Companies/helpers';
import { format } from 'date-fns';
import cn from 'classnames';
import { formatLicensePlate } from '../../../utils/string';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import NotificationComponent from '../../../containers/App/Components/Notification/Notification';

import styles from './create.module.css';

dayjs.extend(customParseFormat);

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid #86b7fe' : '1px solid grey')};
  box-shadow: ${props => (!!props.isActive ? '0 0 0 0.25rem #0d6efd40' : 'none')};

  border-radius: 6px;
  padding: 12px;
  width: calc(33% - 10px);
  font-size: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const DIRECTION_OPTIONS = [
  { label: 'outgoing', value: 'outgoing' },
  { label: 'incoming', value: 'incoming' },
];

const BTW_OPTIONS = [
  { label: 'Excl. BTW', value: 1 },
  { label: 'Incl. BTW', value: 0 },
];

const INCOMING_COSTS_OPTIONS = Object.values(IncomingCostTypes)?.map(cost => ({
  value: cost,
  label: cost.toLowerCase().replaceAll('_', ' '),
}));

const OUTGOING_COSTS_OPTIONS = Object.values(OutgoingCostTypes)?.map(cost => ({
  value: cost,
  label: cost.toLowerCase().replaceAll('_', ' '),
}));

const TRANSPORT_OPTIONS = [
  { label: 'is_available', value: 'is_available' },
  { label: 'pickup', value: 'pickup' },
  { label: 'deliver', value: 'deliver' },
];

const STATE = {
  direction: 'outgoing',
  selectedCompanyId: null,
  selectedCompanyLabel: null,
  editCompany: true,
  selectedTransport: null,
  selectedTransportLabel: '',
  releaseBeforeIncoming: false,
  releaseBeforeOutgoing: false,
  date: null,
  dueDate: null,
  selectedUserLabel: null,
  selectedUserId: null,
  selectedAddress: null,
  selectedVehicle: null,
  editVehicle: true,
  excludeBTW: 1,
  excludeBTWLabel: 'Excl. BTW',
  price: '',
  selectedCost: null,
  selectedCostLabel: '',
  addedCosts: [],
  addedCostsLabels: [],
  bpmValue: null,
  isFinal: false,
  financialTotalAmount: null,
  economicalTotalAmount: null,
  invoiceSubjects: [],
  // paidDate: null,
  // desiredDeliveryDate: null,
  // incoming: null,
  // payments: null,
  // creatorId: null,
  // creatorLabel: null,
  type: 'invoice',
  // typeLabel: null,
  // typeEdit: false,
  // selectedType: null,
  // selectedTypeLabel: null,
  // status: null,
  // statusLabel: null,
  // statusEdit: false,
  // selectedStatus: null,
  // selectedStatusLabel: null,
  // relationSources: [],
  step: 1,
  showNotification: false,
};

/* eslint-disable react/prefer-stateless-function */
class InvoiceCreateComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  handleNext = () => {
    this.setState(prevState => ({
      step: prevState.step + 1,
    }));
  };

  handlePrev = () => {
    this.setState(prevState => ({
      step: prevState.step - 1,
    }));
  };

  onDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('date', date);
    return this;
  }

  onDueDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('dueDate', date);
    return this;
  }

  onPaidDateChange(value) {
    this.updateState('paidDate', value);
    return this;
  }

  onDesiredDeliveryDateChange(value) {
    this.updateState('desiredDeliveryDate', value);
    return this;
  }

  get locale() {
    return this.props.locale;
  }

  get dto() {
    return {
      separateInvoice: {
        date: this.state.date,
        direction: this.state.direction,
        //discount: this.state.discount,
        dueDate: this.state.dueDate,
        //desiredDeliveryDate: this.state.desiredDeliveryDate,
        // economicalTotalAmount: this.state.economicalTotalAmount,
        financialTotalAmount: this.state.financialTotalAmount,
        isFinal: this.state.isFinal,
        //paidDate: this.state.paidDate,
        //payments: this.state.payments,
        //incoming: this.state.incoming,
        // statusId: this.state.status,
        type: this.state.type ?? 'invoice',
        //userCreatorId: this.state.userCreatorId,
        incomingCompanyId: this.state.direction === 'incoming' ? this.state.selectedCompanyId : null,
        outgoingCompanyId: this.state.direction === 'outgoing' ? this.state.selectedCompanyId : null,
        transportLocationId: this.state?.selectedAddress?.id ?? null,
        transport: this.state.direction === 'incoming' ? this.state.selectedTransportLabel : null,
        release_before_incoming_transport: this.state.direction === 'incoming' ? this.state.releaseBeforeIncoming : null,
        release_before_outgoing_transport: this.state.direction === 'outgoing' ? this.state.releaseBeforeOutgoing : null,
        subjectType: this.props.match.params.type === 'product' ? this.props.match.params.type : null,
      },
      invoiceSubjects: this.state.invoiceSubjects,
      relationSources: this.state.relationSources?.map(s => {
        return { description: s.description };
      }),
    };
  }

  get isSetNotApprovedCompany() {
    return (
      this.props.config.appClientId == WIENTJES_INSTALATION.APP_CLIENT_ID &&
      this.state.companyStatus == '1' &&
      this.state.putOnApprovedDate &&
      getDaysBetweenDates(this.state.putOnApprovedDate, formatedDateNow()) > 365
    );
  }

  onCreate() {
    this.props.create(this.dto, result => {
      if (this.isSetNotApprovedCompany) {
        this.props.setCompanyProperty(this.state.selectedCompanyId, 'status', '0', () => {});
      }
      this.reset();
      this.to(`/invoices/${result.id}`);
    });
  }

  onIsFinalChanged() {
    this.setState(prev => {
      return { ...prev, isFinal: !prev.isFinal };
    });
  }

  reset() {
    this.setState(prev => {
      return { ...STATE, invoiceSubjects: STATE.invoiceSubjects, relationSources: STATE.relationSources };
    });
  }

  // updated methods
  setDirection = e => {
    const { value } = e;
    this.setState({
      direction: value,
    });
  };

  setExclBTW = e => {
    const { value, label } = e;
    this.setState({
      excludeBTW: value,
      excludeBTWLabel: label,
    });
  };

  toggleEditCompany = () => {
    this.setState({ editCompany: true });
  };

  toggleEditVehicle = () => {
    this.setState({ editVehicle: true });
  };

  onChangeCompanySelection(company) {
    this.setState(
      prev => ({
        ...prev,
        selectedCompanyLabel: company.label ?? '',
        selectedCompanyId: company.id,
        putOnApprovedDate: company.put_on_approved_date ?? '',
        companyStatus: company.status ?? '',
        editCompany: false,
      }),
      this.props.fetchCompany(company.id, result => {
        if (result.id) {
          const defautltTransportType = getPropByName(result, 'prefence_incoming_transport');
          const defaultReleaseBeforeIncoming = getPropByName(result, 'release_before_incoming_transport');
          const defaultReleaseBeforeOutgoing = getPropByName(result, 'release_before_outgoing_transport');
          const isBlockIncoming = getPropByName(result, `incoming_block`);
          const isBlockOutgoing = getPropByName(result, `outgoing_block`);
          this.setState({ incoming_block: isBlockIncoming, outgoing_block: isBlockOutgoing });
          defautltTransportType
            ? this.setState({
                selectedTransport: defautltTransportType,
                selectedTransportLabel: defautltTransportType,
                defautltTransport: defautltTransportType,
              })
            : this.setState({
                selectedTransport: null,
                selectedTransportLabel: '',
                defautltTransport: '',
              });
          defaultReleaseBeforeIncoming
            ? this.setState({
                releaseBeforeIncoming: defaultReleaseBeforeIncoming,
              })
            : this.setState({ releaseBeforeIncoming: false });

          defaultReleaseBeforeOutgoing
            ? this.setState({
                releaseBeforeOutgoing: defaultReleaseBeforeOutgoing,
              })
            : this.setState({ releaseBeforeOutgoing: false });
        }
      }),
    );
  }

  selectTransportType = e => {
    this.setState({ selectedTransport: e.value, selectedTransportLabel: e.label });
  };

  onReleaseTransportChange() {
    this.state.direction === 'incoming'
      ? this.setState(prev => {
          return { ...prev, releaseBeforeIncoming: !prev.releaseBeforeIncoming };
        })
      : this.setState(prev => {
          return { ...prev, releaseBeforeOutgoing: !prev.releaseBeforeOutgoing };
        });
  }

  onChangeVehicle = vehicle => {
    this.setState(
      prev => ({
        ...prev,
        selectedVehicle: vehicle,
        editVehicle: false,
      }),
      () => {
        this.addInvoiceSubject('vehicle');
        this.addInvoiceSubject('BPM');
      },
    );
  };

  setCompanyUser = e => {
    this.setState({ selectedUserId: e.value, selectedUserLabel: e.label });
  };

  getUserOptions = () => {
    return this.props.fetchedCompany?.users?.map(user => {
      const name = user.properties?.find(p => p?.name?.name === 'name')?.value;
      const surname = user.properties?.find(p => p?.name?.name === 'surname')?.value;
      const fullName = name && surname ? `${name} ${surname}` : user?.email_address;
      return { value: user.id, label: fullName };
    });
  };

  handleSetAddress = address => {
    this.setState({ selectedAddress: address });
  };

  timeout(fn, ms, clear) {
    if (clear) clearTimeout(clear);
    let t = setTimeout(fn, ms);
    this._timeouts.push(t);
    return t;
  }

  onPriceChange = e => {
    const { value } = e.target;
    this.setState({ price: +value });
    this._t = this.timeout(this.calculateAmounts('vehicle', value), 300, this._t);
  };

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }

  addInvoiceSubject = (type, costType) => {
    if (!this.state.selectedVehicle) return;
    const basicSubject = {
      type,
    };
    if (type === 'BPM') {
      basicSubject.description = 'BPM';
    }
    if (type === 'cost') {
      basicSubject.costType = costType;
      let _description = costType.toLowerCase().replaceAll('_', ' ');
      basicSubject.description = _description[0].toUpperCase() + _description.slice(1);
    }
    if (type === 'vehicle') {
      basicSubject.tax_type = this.state.selectedVehicle?.tax_type;
      basicSubject.vehicleId = this.state.selectedVehicle?.id;
    }
    if (this.state.invoiceSubjects?.length && type === 'vehicle') {
      this.setState(prev => ({ ...prev, invoiceSubjects: prev.invoiceSubjects.splice(0, 1, { ...basicSubject }) }));
    } else {
      this.setState(prev => ({ ...prev, invoiceSubjects: [...prev.invoiceSubjects, { ...basicSubject }] }));
    }
  };

  removeInvoiceSubject = (type, costType) => {
    const updated = this.state.invoiceSubjects.filter(is => is?.type !== type && is?.costType !== costType);
    const financialTotalAmount = updated.reduce((total, subject) => {
      total += +subject.price ?? 0;
      return total;
    }, 0);
    this.setState({ invocesSubjects: [...updated], financialTotalAmount });
  };

  calculateAmounts = (type, rawValue, cost_type) => {
    const { selectedVehicle, direction, excludeBTW, selectedCompanyId } = this.state;
    const value = !rawValue ? 0 : +rawValue;

    const subject = {
      subject_type: type,
      direction,
      salesAmounts: {},
      financialAmounts: {},
      incomingCompanyId: null,
      outgoingCompanyId: null,
    };

    if (type === 'vehicle') {
      subject.vehicleId = selectedVehicle?.id;

      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.salesAmounts.financial_price_excl_vat_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.salesAmounts.financial_price_incl_vat_bpm = value;
        }
        if (!!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.salesAmounts.financial_price_marge_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.salesAmounts.financial_price_marge_bpm = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.financialAmounts.financial_price_excl_vat_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.financialAmounts.financial_price_incl_vat_bpm = value;
        }
        if (!!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.financialAmounts.financial_price_marge_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.financialAmounts.financial_price_marge_bpm = value;
        }
      }
    } else if (type === 'cost') {
      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW) {
          subject.salesAmounts.cost_price_excl_vat = value;
        } else {
          subject.salesAmounts.cost_price_incl_vat = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW) {
          subject.financialAmounts.cost_price_excl_vat = value;
        } else {
          subject.financialAmounts.cost_price_incl_vat = value;
        }
      }
    } else if (type === 'BPM') {
      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW) {
          subject.salesAmounts.bpm_price_excl_vat = value;
        } else {
          subject.salesAmounts.bpm_price_incl_vat = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW) {
          subject.financialAmounts.bpm_price_excl_vat = value;
        } else {
          subject.financialAmounts.bpm_price_incl_vat = value;
        }
      }
    }
    this.props.calculateFinancialAmounts(subject, result => {
      if (type !== 'vehicle') {
        delete result?.description;
      }
      const updatedSubjects = [...this.state.invoiceSubjects];
      const positionToUpdate = cost_type
        ? updatedSubjects.findIndex(sub => sub?.costType === cost_type)
        : updatedSubjects.findIndex(sub => sub?.type === type);
      if (positionToUpdate >= 0) {
        updatedSubjects[positionToUpdate] = { ...updatedSubjects[positionToUpdate], ...result };
        const updatedTotal = updatedSubjects.reduce((total, subject) => {
          if (!!subject.price) {
            total += subject.price;
          }
          return total;
        }, 0);
        this.setState({ invoiceSubjects: [...updatedSubjects], financialTotalAmount: updatedTotal });
      }
    });
  };

  selectCost = e => {
    this.setState({ selectedCost: e.value, selectedCostLabel: e.label });
  };

  addCost = () => {
    if (!this.state.selectedCost || !this.state.selectedCostLabel) return;
    const newCostType = this.state.selectedCost;
    this.setState(
      prev => ({
        ...prev,
        addedCosts: [...prev.addedCosts, { type: prev.selectedCost, value: 0 }],
        addedCostsLabels: [...prev.addedCostsLabels, prev.selectedCostLabel],
        selectedCost: null,
        selectedCostLabel: '',
      }),
      this.addInvoiceSubject('cost', newCostType),
    );
  };

  removeCost = idx => {
    this.removeInvoiceSubject('cost', this.state.addedCostsLabels[idx]);
    this.setState(prev => ({
      ...prev,
      addedCosts: prev.addedCosts.filter((c, i) => i !== idx),
      addedCostsLabels: prev.addedCostsLabels.filter((c, i) => i !== idx),
    }));
  };

  onCostChange = (e, idx) => {
    const { value } = e.target;
    const updatedCosts = [...this.state.addedCosts];
    updatedCosts[idx].value = value;
    this.setState({ addedCosts: [...updatedCosts] });
    this._t = this.timeout(this.calculateAmounts('cost', value, this.state.addedCosts[idx].type), 300, this._t);
  };

  onBpmChange = e => {
    const { value } = e.target;
    this.setState({ bpmValue: value });
    this._t = this.timeout(this.calculateAmounts('BPM', value), 300, this._t);
  };
  handleShowNotification = () => {
    this.setState({ showNotification: true });
  };

  render() {
    const propVal = name =>
      this.state.selectedVehicle?.properties?.find(p => p.propertyName.name === name)?.propertyValue.value || '';

    const EURFormat = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format;

    let costsOptions = this.state.direction === 'outgoing' ? OUTGOING_COSTS_OPTIONS : INCOMING_COSTS_OPTIONS;
    costsOptions = costsOptions.filter(cost => !this.state.addedCostsLabels.includes(cost?.label));
    const { step } = this.state;

    return (
      <div className={styles.container}>
        <div className={cn('progress mb-2', styles.progress)}>
          <div
            className={cn('progress-bar', styles.progressBar)}
            role="progressbar"
            style={{ width: `${(step - 1) * 33.33 + 33.33}%` }}
            aria-valuenow={step}
            aria-valuemin="1"
            aria-valuemax="3"
          >
            {step} of 3
          </div>
        </div>
        <form>
          {step === 1 && (
            <>
              <div>
                <div className={styles.containerDropdown}>
                  <label className="form-label">{this.lbl('invoice.create.direction')}</label>

                  <Dropdown
                    className={styles.dropdown}
                    options={DIRECTION_OPTIONS}
                    value={this.state.direction}
                    onChange={this.setDirection}
                  />
                </div>

                <div className="mb-2">
                  <CheckboxComponent
                    label={this.lbl('invoice.create.finalized')}
                    checked={this.state.isFinal}
                    onChange={this.onIsFinalChanged.bind(this)}
                  />
                </div>
              </div>
              <div className="">
                <div>
                  <label className="form-label">{this.lbl('invoice.create.date')}</label>
                  <DatePicker
                    className={styles.datePicker}
                    dateFormat="dd-MM-yyyy"
                    selected={this.state.date && dayjs(this.state.date).toDate()}
                    onChange={this.onDateChange.bind(this)}
                  />
                </div>

                <div>
                  <label className="form-label">{this.lbl('invoice.create.dueDate')}</label>
                  <DatePicker
                    className={styles.datePicker}
                    dateFormat="dd-MM-yyyy"
                    selected={this.state.dueDate && dayjs(this.state.dueDate).toDate()}
                    onChange={this.onDueDateChange.bind(this)}
                  />
                </div>
              </div>
              <div>
                <label className="form-label">
                  <span style={{ textTransform: 'capitalize' }}>{this.state.direction}</span> company
                </label>

                <FontAwesomeIcon icon={faEdit} style={{ width: 20, marginLeft: 5 }} onClick={this.toggleEditCompany} />

                {this.state.editCompany || !this.state.selectedCompanyId ? (
                  <CompanySelection
                    className={styles.selection}
                    order
                    user={{ id: this.state.selectedCompanyId }}
                    onSelect={this.onChangeCompanySelection.bind(this)}
                  />
                ) : (
                  <input
                    readOnly
                    className={cn('form-control', styles.inputSelection)}
                    type="text"
                    placeholder={this.state.selectedCompanyLabel}
                  />
                )}

                {this.state[`${this.state.direction}_block`] === '1' && (
                  <NotificationComponent
                    show={this.handleShowNotification()}
                    onClose={() => this.setState({ showNotification: false })}
                    variant={'warning'}
                    text={this.lbl('company.block_invoice_sorry')}
                  />
                )}

                <label className="form-label mt-2">Company contact</label>
                <div className={styles.containerDropdown}>
                  <Dropdown
                    className={styles.dropdown}
                    onChange={this.setCompanyUser}
                    value={this.state.selectedUserLabel ?? ''}
                    options={this.getUserOptions() ?? []}
                    disabled={!this.state.selectedCompanyId}
                  />
                </div>
              </div>

              {!!this.state.selectedCompanyId && !!this.props.fetchedCompany && (
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {this.props.fetchedCompany?.addresses?.map(address => (
                    <Address
                      key={`${address?.id}`}
                      onClick={() => this.handleSetAddress(address)}
                      isActive={this.state.selectedAddress?.id === address?.id}
                    >
                      <VBox left>
                        <HBox vCenter>
                          <h3 className="name">{address?.name}</h3>
                          <CheckboxComponent checked={this.state.selectedAddress?.id === address?.id} />
                        </HBox>
                        <VBox className="address" left>
                          <div>{address?.addressLine1}</div>
                          <div>
                            {address?.postcode} {address?.city}
                          </div>
                          <div>{address.country?.name}</div>
                        </VBox>
                      </VBox>
                    </Address>
                  ))}
                </div>
              )}
            </>
          )}

          {step === 2 && (
            <>
              {this.state.direction == 'incoming' && (
                <div>
                  <label className="form-label">Transport</label>
                  <Dropdown
                    className={styles.dropdown}
                    options={TRANSPORT_OPTIONS}
                    value={this.state.defautltTransport || this.state.selectedTransportLabel}
                    onChange={this.selectTransportType}
                  />
                  <div className="mb-2">
                    <CheckboxComponent
                      label={this.lbl('invoice.create.release_before_incoming_transport')}
                      checked={this.state.releaseBeforeIncoming}
                      onChange={this.onReleaseTransportChange.bind(this)}
                    />
                  </div>
                </div>
              )}
              {this.state.direction === 'outgoing' && (
                <div className="mb-2">
                  <CheckboxComponent
                    label={this.lbl('invoice.create.release_before_outgoing_transport')}
                    checked={this.state.releaseBeforeOutgoing}
                    onChange={this.onReleaseTransportChange.bind(this)}
                  />
                </div>
              )}
              <label className="form-label">Vehicle</label>
              <FontAwesomeIcon icon={faEdit} style={{ width: 20, marginLeft: 5 }} onClick={this.toggleEditVehicle} />

              {!this.state.selectedVehicle || !!this.state.editVehicle ? (
                <VehicleSelection className={styles.selection} onSelect={this.onChangeVehicle} />
              ) : (
                <div className="form-label">
                  {this.state.selectedVehicle?.brand_name
                    ? `${this.state.selectedVehicle?.brand_name} ${this.state.selectedVehicle?.model_name}`
                    : this.state.selectedVehicle.id}
                </div>
              )}

              <div className={cn('text-muted', styles.gridCard)}>
                <div>
                  <h6 className={styles.gridCardItem}>Regplate:</h6>
                  <h6 className={styles.gridCardItem}>VIN:</h6>
                  <h6 className={styles.gridCardItem}>Brand:</h6>
                  <h6 className={styles.gridCardItem}>Model:</h6>
                  <h6 className={styles.gridCardItem}>Date first allowance:</h6>
                  <h6 className={styles.gridCardItem}>Mileage:</h6>
                  <h6 className={styles.gridCardItem}>Color:</h6>
                </div>
                {this.state.selectedVehicle && (
                  <div>
                    <h6 className={styles.gridCardItem}>
                      {formatLicensePlate(this.state.selectedVehicle?.regplate || '-')}
                    </h6>
                    <h6 className={styles.gridCardItem}>{this.state.selectedVehicle?.vin ?? '-'}</h6>
                    <h6 className={styles.gridCardItem}>{`${this.state.selectedVehicle.brand_name ?? '-'} ${this.state
                      .selectedVehicle.model_name ?? '-'}`}</h6>
                    <h6 className={styles.gridCardItem}>{this.state.selectedVehicle.model_info ?? '-'}</h6>
                    <h6 className={styles.gridCardItem}>
                      {dayjs(this.state.selectedVehicle.date_first_allowance).format('DD-MM-YYYY') ?? '-'}
                    </h6>
                    <h6 className={styles.gridCardItem}>
                      {parseInt(this.state.selectedVehicle.mileage || '0').toLocaleString() + ' km'}
                    </h6>
                    <h6 className={styles.gridCardItem}>{this.state.selectedVehicle.base_color ?? '-'}</h6>
                  </div>
                )}
              </div>
            </>
          )}
          {step === 3 && (
            <>
              <>
                <label className="form-label">BTW</label>
                <div className={styles.containerDropdown}>
                  <Dropdown
                    className={styles.dropdown}
                    options={BTW_OPTIONS}
                    value={this.state.excludeBTWLabel ?? ''}
                    onChange={this.setExclBTW}
                  />
                </div>

                <label className="form-label">Costs</label>
                <div className="d-flex gap-2 align-items-baseline">
                  <div className={styles.containerDropdown}>
                    <Dropdown
                      className={styles.dropdown}
                      options={costsOptions}
                      value={this.state.selectedCostLabel}
                      onChange={this.selectCost}
                    />
                  </div>
                  <div className={styles.buttonDelete}>
                    <ButtonComponent style={'ButtonSoftEdit'} size={'btn-sm'} onClick={this.addCost}>
                      Add
                    </ButtonComponent>
                  </div>
                </div>
                {this.state.addedCostsLabels?.map((cost, idx) => (
                  <div key={cost}>
                    <FormField className={styles.formField} label={cost}>
                      <input
                        className={cn('form-control', styles.inputField)}
                        name={cost}
                        type="number"
                        step="0.01"
                        min="0.00"
                        value={this.state.addedCosts[idx]?.value}
                        onChange={e => this.onCostChange(e, idx)}
                      />
                      <div className={styles.buttonDelete}>
                        <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={() => this.removeCost(idx)}>
                          Delete
                        </ButtonComponent>
                      </div>
                    </FormField>
                  </div>
                ))}

                <FormField className={styles.formField} label="Price: ">
                  <input
                    className={styles.inputField}
                    name="price"
                    type="number"
                    step="0.01"
                    min="0.00"
                    value={this.state.price}
                    onChange={this.onPriceChange}
                  />
                </FormField>

                <FormField className={styles.formField} label="BPM: ">
                  <input
                    className={styles.inputField}
                    name="bpm"
                    type="number"
                    step="0.01"
                    min="0.00"
                    readonly
                    value={this.state.bpmValue ?? ''}
                    onChange={this.onBpmChange}
                  />
                </FormField>
              </>

              {!!this.state.financialTotalAmount && (
                <HBox vCenter>
                  <VBox left style={{ maxWidth: 350 }}></VBox>
                </HBox>
              )}

              {!!this.state.financialTotalAmount && (
                <div className="d-flex gap-3 align-content-center align-items-end justify-content-between">
                  <div>
                    <h4>Total:</h4>
                  </div>
                  <div>{EURFormat(this.state.financialTotalAmount)}</div>
                </div>
              )}
            </>
          )}
          <div className={cn('d-flex', 'gap-2', styles.buttonGroup)}>
            <ButtonComponent onClick={this.handlePrev} disabled={step === 1} style={'ButtonSoftPrimary'}>
              Back
            </ButtonComponent>

            {step < 3 ? (
              <ButtonComponent onClick={this.handleNext} style={'ButtonSoftPrimary'}>
                Next
              </ButtonComponent>
            ) : (
              <div className="d-flex gap-2">
                <ButtonComponent onClick={this.reset.bind(this)} style={'ButtonSoftDelete'}>
                  {this.lbl('invoice.create.reset')}
                </ButtonComponent>
                {this.state.selectedVehicle?.id && (
                  <ButtonComponent
                    disabled={this.state[`${this.state.direction}_block`] === '1'}
                    onClick={this.onCreate.bind(this)}
                    style={'ButtonSoftEdit'}
                  >
                    {this.lbl('invoice.create.createBtn')}
                  </ButtonComponent>
                )}
              </div>
            )}
          </div>
        </form>
      </div>
    );
  }
}

InvoiceCreateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    fetchedCompany: selectCompany(),
    config: selectConfig(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(dto, callback) {
      dispatch(createInvoice(dto, callback));
    },
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
    setCompanyProperty(companyId, propertyName, propertyValue, callback) {
      dispatch(setCompanyProperty(companyId, propertyName, propertyValue, callback));
    },
    calculateFinancialAmounts(subject, callback) {
      dispatch(calculateFinancialAmounts(subject, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceCreate = compose(withConnect, withRouter)(InvoiceCreateComp);
